import { useEffect } from "react";
import { getSeoForPath, SITE_URL } from "../seo/routeSeo";

function upsertMeta({ name, property, content }) {
  const selector = name ? `meta[name="${name}"]` : `meta[property="${property}"]`;
  let meta = document.head.querySelector(selector);
  if (!meta) {
    meta = document.createElement("meta");
    if (name) meta.setAttribute("name", name);
    if (property) meta.setAttribute("property", property);
    document.head.appendChild(meta);
  }
  meta.setAttribute("content", content);
}

function upsertCanonical(href) {
  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", href);
}

function upsertJsonLd(seo, language) {
  const scriptId = "cb-seo-jsonld";
  const existing = document.getElementById(scriptId);
  if (existing) existing.remove();

  if (!seo.index) return;

  const payload = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: seo.title,
    description: seo.description,
    url: seo.canonical,
    inLanguage: language === "fr" ? "fr-CA" : "en-CA",
    isPartOf: {
      "@type": "WebSite",
      name: "ColoBongo",
      url: SITE_URL
    }
  };

  const script = document.createElement("script");
  script.id = scriptId;
  script.type = "application/ld+json";
  script.text = JSON.stringify(payload);
  document.head.appendChild(script);
}

export default function RouteSEO({ pathname, language }) {
  useEffect(() => {
    const seo = getSeoForPath(pathname, language);
    document.title = seo.title;
    document.documentElement.lang = language === "fr" ? "fr-CA" : "en-CA";

    upsertMeta({ name: "description", content: seo.description });
    upsertMeta({ name: "robots", content: seo.robots });

    upsertMeta({ property: "og:title", content: seo.title });
    upsertMeta({ property: "og:description", content: seo.description });
    upsertMeta({ property: "og:url", content: seo.canonical });
    upsertMeta({ property: "og:type", content: "website" });
    upsertMeta({ property: "og:site_name", content: "ColoBongo" });
    upsertMeta({ property: "og:locale", content: language === "fr" ? "fr_CA" : "en_CA" });

    upsertMeta({ name: "twitter:card", content: "summary_large_image" });
    upsertMeta({ name: "twitter:title", content: seo.title });
    upsertMeta({ name: "twitter:description", content: seo.description });

    upsertCanonical(seo.canonical);
    upsertJsonLd(seo, language);
  }, [pathname, language]);

  return null;
}
